import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { CountdownTimer } from './CountdownTimer';
import { trackAddToCart } from '../utils/trackAddToCart';
const CART_URL = 'https://mujeresempoderadas.lat/cart/add?id=52459756126507&quantity=1';
export function SalesLetter() {
  return <section className="w-full" style={{
    background: 'var(--bg-surface)'
  }} aria-label="Carta de ventas" data-id="element-176">
      <div className="max-w-2xl mx-auto px-4 py-10 md:py-16" data-id="element-177">
        {/* ── Pain Points ── */}
        <div className="mb-10" data-id="element-178">
          <div className="section-accent" data-id="element-179" />
          <p className="eyebrow text-center mb-3" data-id="element-180">¿Te suena familiar?</p>
          <h2 className="text-2xl md:text-3xl text-center mb-7" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }} data-id="element-181">
            Este sistema es para vos si alguna vez...
          </h2>

          <div className="space-y-3" data-id="element-182">
            <div className="pain-card" data-id="element-183">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-184">❌</span>
              <p className="text-sm md:text-base leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-185">
                Terminás{' '}
                <strong style={{
                color: 'var(--text-primary)'
              }} data-id="element-186">
                  pidiendo delivery por agotamiento
                </strong>{' '}
                y después sentís culpa por el gasto y la mala alimentación.
              </p>
            </div>
            <div className="pain-card" data-id="element-187">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-188">❌</span>
              <p className="text-sm md:text-base leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-189">
                Intentás organizarte el domingo pero{' '}
                <strong style={{
                color: 'var(--text-primary)'
              }} data-id="element-190">
                  para el martes ya estás improvisando de vuelta.
                </strong>
              </p>
            </div>
            <div className="pain-card" data-id="element-191">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-192">❌</span>
              <p className="text-sm md:text-base leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-193">
                Vivís lavando platos a cualquier hora como si{' '}
                <strong style={{
                color: 'var(--text-primary)'
              }} data-id="element-194">
                  tu cocina fuera un restaurante que nunca cierra.
                </strong>
              </p>
            </div>
            <div className="pain-card" data-id="element-195">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-196">❌</span>
              <p className="text-sm md:text-base leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-197">
                Sentís que{' '}
                <strong style={{
                color: 'var(--text-primary)'
              }} data-id="element-198">
                  comer bien requiere tiempo y plata que simplemente no tenés.
                </strong>
              </p>
            </div>
            <div className="pain-card" data-id="element-199">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-200">❌</span>
              <p className="text-sm md:text-base leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-201">
                <em data-id="element-202">
                  Sentir que no te alcanza el tiempo (ni la energía, ni las
                  ganas) para darle a tu familia la alimentación que se merece.
                </em>
              </p>
            </div>
          </div>
        </div>

        {/* ── Product Intro ── */}
        <div className="text-center mb-10" data-id="element-203">
          <p className="eyebrow mb-3" data-id="element-204">Presentamos...</p>
          <h2 className="text-3xl md:text-4xl mb-2" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }} data-id="element-205">
            <span style={{
            textDecoration: 'underline',
            textDecorationColor: 'var(--color-gold)',
            textUnderlineOffset: '5px',
            textDecorationThickness: '1.5px'
          }} data-id="element-206">
              Sistema 10x2™
            </span>
          </h2>
          <p className="text-base md:text-lg italic mb-7" style={{
          fontFamily: 'var(--font-heading)',
          color: 'var(--text-muted)',
          fontWeight: 500
        }} data-id="element-207">
            "La Guía Definitiva Para Resolver Tu Cocina De Una Vez Por Todas"
          </p>

          {/* Product mockup */}
          <div className="w-full max-w-xs mx-auto rounded-2xl mb-5 overflow-hidden" style={{
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-md)'
        }} aria-label="Mockup producto Sistema 10x2™" data-id="element-208">
            <img src="https://cdn.magicpatterns.com/uploads/avXfojrAUQ7PsUmUipPzNu/20260303_1146_Image_Generation_remix_01kjt2hag0fe6swnp6e4ws1vcz_(1).webp" alt="Sistema 10x2™ — Producto completo con bonos" className="w-full h-auto object-cover" style={{
            display: 'block'
          }} data-id="element-209" />
          </div>

          <p className="text-xs font-semibold uppercase tracking-widest mb-5" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-muted)',
          letterSpacing: '0.18em'
        }} data-id="element-210">
            Producto Digital — Descarga Inmediata
          </p>

          {/* Product name badge */}
          <div className="inline-block px-6 py-4 rounded-xl mb-5" style={{
          background: 'var(--bg-dark)',
          color: 'var(--text-inverse)'
        }} data-id="element-211">
            <p className="text-lg font-bold m-0" style={{
            fontFamily: 'var(--font-heading)',
            letterSpacing: '-0.01em'
          }} data-id="element-212">
              Sistema 10x2™
            </p>
            <p className="text-xs m-0 mt-1" style={{
            fontFamily: 'var(--font-body)',
            color: 'rgba(255,255,255,0.5)',
            letterSpacing: '0.04em'
          }} data-id="element-213">
              10 Días de Comida · 2 Horas de Cocina · Cero Estrés
            </p>
          </div>

          {/* Stats */}
          <div className="flex flex-nowrap justify-center gap-3 mb-7" data-id="element-214">
            <div className="flex flex-col items-center px-4 py-3 rounded-xl flex-1" style={{
            background: 'var(--bg-muted)',
            border: '1px solid var(--border-default)'
          }} data-id="element-215">
              <span className="text-2xl font-bold" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-gold)'
            }} data-id="element-216">
                50+
              </span>
              <span className="text-xs mt-0.5 text-center" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-217">
                Recetas Incluidas
              </span>
            </div>
            <div className="flex flex-col items-center px-4 py-3 rounded-xl flex-1" style={{
            background: 'var(--bg-muted)',
            border: '1px solid var(--border-default)'
          }} data-id="element-218">
              <span className="text-2xl font-bold" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-gold)'
            }} data-id="element-219">
                10
              </span>
              <span className="text-xs mt-0.5 text-center" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-220">
                Días Resueltos
              </span>
            </div>
            <div className="flex flex-col items-center px-4 py-3 rounded-xl flex-1" style={{
            background: 'var(--bg-muted)',
            border: '1px solid var(--border-default)'
          }} data-id="element-221">
              <span className="text-2xl font-bold" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-gold)'
            }} data-id="element-222">
                2 hs
              </span>
              <span className="text-xs mt-0.5 text-center" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-223">
                De Cocina Total
              </span>
            </div>
          </div>
        </div>

        {/* ── Main pitch ── */}
        <div className="rounded-2xl p-6 md:p-8 mb-8" style={{
        background: 'var(--bg-muted)',
        border: '1px solid var(--border-default)'
      }} data-id="element-224">
          <p className="text-base md:text-lg leading-relaxed m-0" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-secondary)'
        }} data-id="element-225">
            Resolvé la comida de{' '}
            <strong style={{
            color: 'var(--text-primary)'
          }} data-id="element-226">
              10 días enteros
            </strong>{' '}
            con un sistema paso a paso...{' '}
            <em data-id="element-227">
              incluso si llegás sin ganas de cocinar, con poco presupuesto o una
              cocina chiquita.
            </em>
          </p>
        </div>

        {/* ── Inline pricing ── */}
        <div className="mb-8" data-id="element-228">
          {/* Price card */}
          <div className="rounded-2xl p-7 text-center mb-4" style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-sm)'
        }} data-id="element-229">
            <p className="eyebrow mb-4" data-id="element-230">Precio de oferta:</p>
            <p className="text-2xl line-through mb-1" style={{
            fontFamily: 'var(--font-body)',
            color: 'var(--text-muted)'
          }} data-id="element-231">
              $87.995 ARS
            </p>
            <p className="text-5xl font-bold mb-4" style={{
            fontFamily: 'var(--font-heading)',
            color: 'var(--color-primary)',
            lineHeight: 1.1,
            letterSpacing: '-0.02em'
          }} data-id="element-232">
              $19.999 ARS
            </p>
            <p className="text-sm m-0" style={{
            fontFamily: 'var(--font-body)',
            color: 'var(--text-muted)'
          }} data-id="element-233">
              Pago único · Sin suscripciones · Sin cargos ocultos
            </p>
          </div>
          {/* Gold CTA — outside the card */}
          <a href={CART_URL} onClick={trackAddToCart} className="btn-cta-gold btn-cta-gold-pulse w-full text-base md:text-lg px-6 py-4 rounded-xl mb-2 block text-center" data-id="element-234">
            QUIERO MI SISTEMA 10x2™ &gt;&gt;
          </a>
          <p className="text-sm text-center" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--color-accent)'
        }} data-id="element-235">
            ✓ Descarga inmediata de todo el paquete
          </p>
        </div>

        {/* ── Urgency + timer ── */}
        <div className="rounded-2xl p-6 text-center mb-10" style={{
        background: 'var(--bg-dark)'
      }} data-id="element-236">
          <p className="font-bold text-sm uppercase tracking-widest mb-2" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--color-gold)',
          letterSpacing: '0.18em'
        }} data-id="element-237">
            🔥 OFERTA SOLO POR HOY
          </p>
          <p className="text-sm mb-4" style={{
          fontFamily: 'var(--font-body)',
          color: 'rgba(255,255,255,0.55)'
        }} data-id="element-238">
            Reserva válida por 15 minutos. Si no accedés, tu descuento pasa a la
            siguiente persona.
          </p>
          <CountdownTimer data-id="element-239" />
        </div>

        {/* ── Results ── */}
        <div className="mb-2" data-id="element-240">
          <div className="section-accent" data-id="element-241" />
          <p className="eyebrow text-center mb-3" data-id="element-242">Resultados concretos</p>
          <h2 className="text-2xl md:text-3xl text-center mb-7" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }} data-id="element-243">
            Esto es lo que vas a lograr con el{' '}
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-244">
              Sistema 10x2™
            </span>
          </h2>

          <div className="space-y-3" data-id="element-245">
            <div className="solution-card" data-id="element-246">
              <span className="text-xl flex-shrink-0" data-id="element-247">🍽️</span>
              <div data-id="element-248">
                <p className="font-bold text-sm md:text-base m-0 mb-1" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-249">
                  10 días de comida resueltos en solo 2 horas
                </p>
                <p className="text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-250">
                  Abrís el freezer, elegís, calentás y servís.{' '}
                  <em data-id="element-251">Cero improvisación, cero estrés.</em>
                </p>
              </div>
            </div>
            <div className="solution-card" data-id="element-252">
              <span className="text-xl flex-shrink-0" data-id="element-253">💰</span>
              <div data-id="element-254">
                <p className="font-bold text-sm md:text-base m-0 mb-1" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-255">
                  Hasta un{' '}
                  <span style={{
                  textDecoration: 'underline',
                  textDecorationColor: 'var(--color-gold)',
                  textUnderlineOffset: '3px'
                }} data-id="element-256">
                    40% menos de gasto en supermercado
                  </span>
                </p>
                <p className="text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-257">
                  Comprás lo justo, en la cantidad justa. Se acabaron los
                  ingredientes que se pudren y las compras de impulso.
                </p>
              </div>
            </div>
            <div className="solution-card" data-id="element-258">
              <span className="text-xl flex-shrink-0" data-id="element-259">🚫</span>
              <div data-id="element-260">
                <p className="font-bold text-sm md:text-base m-0 mb-1" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-261">
                  Chau delivery de culpa
                </p>
                <p className="text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-262">
                  Dejás de tirar plata en comida cara y poco saludable por puro
                  agotamiento. <strong data-id="element-263">Esa plata vuelve a tu bolsillo.</strong>
                </p>
              </div>
            </div>
            <div className="solution-card" data-id="element-264">
              <span className="text-xl flex-shrink-0" data-id="element-265">🌙</span>
              <div data-id="element-266">
                <p className="font-bold text-sm md:text-base m-0 mb-1" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-267">
                  Tus noches libres de vuelta
                </p>
                <p className="text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-268">
                  Llegás del trabajo y la comida ya está lista. Nada de cocinar
                  1 hora después de una jornada agotadora.{' '}
                  <em data-id="element-269">Ese tiempo es tuyo.</em>
                </p>
              </div>
            </div>
            <div className="solution-card" data-id="element-270">
              <span className="text-xl flex-shrink-0" data-id="element-271">❄️</span>
              <div data-id="element-272">
                <p className="font-bold text-sm md:text-base m-0 mb-1" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-273">
                  Un freezer organizado que trabaja por vos
                </p>
                <p className="text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-274">
                  Sabés exactamente qué tenés, qué usar primero y qué reponer.{' '}
                  <strong data-id="element-275">Cero desperdicio, cero "¿qué era esto?".</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}